<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb"/>
    <div class="flexBox">
      <text-title mainTitle="访客申请配置" subheading="" />
      <div>
        <a @click="save">保存</a>
        <a @click="cel">取消</a>
      </div>
    </div>

    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">拜访人是否精确匹配：</span>
        </div>
        <el-switch
          v-model="isMatchingPersonState"
          active-color="#00A0E6">
        </el-switch>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">来访人身份证号是否必填：</span>
        </div>
        <el-switch
          v-model="idCardIsMustState"
          active-color="#00A0E6">
        </el-switch>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">来访人人脸照片是否必填：</span>
        </div>
        <el-switch
          v-model="personPicIsMustState"
          active-color="#00A0E6">
        </el-switch>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">访客权限：</span>
        </div>
        <el-select v-model="openType" size="small" style="width: 280px">
          <el-option v-for="item in openTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">是否需要审批：</span>
        </div>
        <el-switch
          v-model="approveIsMustState"
          active-color="#00A0E6">
        </el-switch>
      </div>

    </form>
  </div>
</template>

<script>
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'
  import {pattern} from '../../../utils/regular'
  import {api} from '../../api/Visitor'
  import TextTitle from '../../../components/Text/TextTitle'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      Breadcrumb,
      TextTitle,
    },
    name: 'visitor-config-modify',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧访客',
            name: 'visitor-device-manage'
          }, {
            value: '访客申请配置'
          }],
        },
        maxlength: 32,
        code: '',
        isMatchingPerson: '',
        idCardIsMust: '',
        personPicIsMust: '',
        approveIsMust: '',
        openType: '',

        isMatchingPersonState: false,
        idCardIsMustState: false,
        personPicIsMustState: false,
        approveIsMustState: false,
        openTypeList: [
          {code: '1', name: '仅拥有被访人所在楼层权限'},
          {code: '2', name: '拥有被访人所有权限'},
        ]
      }
    },
    created () {
      this.getVisitorConfig()
    },
    methods: {
      cel () {
        this.$router.push({
          name: 'visitor-config'
        })
      },
      getVisitorConfig () {
        this.$axios.post(api.getVisitorConfig, {})
          .then(res => {
            let data = res.data.data
            if (data) {
              this.code = data.code
              this.isMatchingPerson  = data.isMatchingPerson
              this.idCardIsMust  = data.idCardIsMust
              this.personPicIsMust  = data.personPicIsMust
              this.approveIsMust = data.approveIsMust
              this.openType = data.openType
            }
            if (this.isMatchingPerson === '1') {
              this.isMatchingPersonState = true
            } else {
              this.isMatchingPersonState = false
            }
            if (this.idCardIsMust === '1') {
              this.idCardIsMustState = true
            } else {
              this.idCardIsMustState = false
            }
            if (this.personPicIsMust === '1') {
              this.personPicIsMustState = true
            } else {
              this.personPicIsMustState = false
            }
            if (this.approveIsMust === '1') {
              this.approveIsMustState = true
            } else {
              this.approveIsMustState = false
            }
          })
          .catch(errorHandler('获取配置数据失败'))
      },
      save () {
        let obj = {
          code: this.code,
          isMatchingPerson: this.isMatchingPerson,
          idCardIsMust: this.idCardIsMust,
          personPicIsMust: this.personPicIsMust,
          approveIsMust: this.approveIsMust,
          openType: this.openType
        }
        this.$axios.post(api.updateVisitorConfig, obj)
          .then(res => {
            nSuccess('修改成功')
            this.cel()
          })
          .catch(errorHandler('修改失败'))
      }
    },
    watch: {
      isMatchingPersonState (val) {
        if (val) {
          this.isMatchingPerson = '1'
        } else {
          this.isMatchingPerson = '0'
        }
      },
      idCardIsMustState (val) {
        if (val) {
          this.idCardIsMust = '1'
        } else {
          this.idCardIsMust = '0'
        }
      },
      personPicIsMustState (val) {
        if (val) {
          this.personPicIsMust = '1'
        } else {
          this.personPicIsMust = '0'
        }
      },
      approveIsMustState (val) {
        if (val) {
          this.approveIsMust = '1'
        } else {
          this.approveIsMust = '0'
        }
      },
    }
  }
</script>

<style scoped>
  .main_right {
    text-align: left;
  }
  .flexBox {
    display: flex;
    justify-content: space-between;
  }

  .flexBox a{
    line-height: 58px;
    margin-right: 40px;
    cursor: pointer;
    color: #00a0e6;
  }
  .flexBox a:hover{
    color: #06b3ff;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 30px 0;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    /*margin-right: 10px;*/
  }
  .textBox {
    display: inline-block;
    width: 240px;
    text-align: right;
    vertical-align: top;
    margin-right: 10px;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>

<style lang="less">
  .main_right {
    .faceConfigTip {
      display: inline-block;
      min-width: 80px;
      text-align: right;
    }
    .faceConfigInput {
      display: inline-block;
      width: 313px;
      height: 28px;
      margin-left: 10px;
      .el-input__inner {
        height: 28px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/VisitorCenter/VisitorConfig/VisitorConfigModify.vue